import axiosPost from "./axiosPost";

export const RNHDepartamentoIns = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoIns",
        params: {
            rnhDepartamentoCod: data?.cod || null,
            rnhDepartamentoNombre: data?.name || null,
            rnhDepartamentoDescripcion: data?.desc || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
